<span>
  <app-platform-icon [platform]="knownPlatform" [size]="size" class="me-1"></app-platform-icon>
  {{name}}
</span>
